(function () {
  'use strict';

  var MIN_PX = 8;
  var STEP = 0.25;
  var EPS = 0.75;

  function fitPromo(promo) {
    if (!promo || promo.dataset.buy3FitDisabled === 'true') return;
    var p = promo.querySelector(':scope > p');
    if (!p) return;

    p.style.removeProperty('font-size');
    var maxPx = parseFloat(window.getComputedStyle(p).fontSize);
    if (!maxPx || maxPx < MIN_PX) maxPx = 14.4;

    p.style.fontSize = maxPx + 'px';
    var guard = 0;
    while (p.scrollWidth > p.clientWidth + EPS && parseFloat(p.style.fontSize) > MIN_PX && guard < 120) {
      var cur = parseFloat(p.style.fontSize);
      p.style.fontSize = cur - STEP + 'px';
      guard++;
    }
  }

  function fitCartDrawerTitleLine(line) {
    if (!line || !window.matchMedia('(min-width: 700px)').matches) return;
    if (line.clientWidth < 24) return;

    line.style.removeProperty('font-size');
    var maxPx = parseFloat(window.getComputedStyle(line).fontSize);
    if (!maxPx || maxPx < MIN_PX) maxPx = 14;

    line.style.fontSize = maxPx + 'px';
    var guard = 0;
    while (line.scrollWidth > line.clientWidth + EPS && parseFloat(line.style.fontSize) > MIN_PX && guard < 120) {
      var cur = parseFloat(line.style.fontSize);
      line.style.fontSize = cur - STEP + 'px';
      guard++;
    }
  }

  function fitAllCartDrawerTitles() {
    document.querySelectorAll('#cart-drawer .line-item__drawer-title-line').forEach(fitCartDrawerTitleLine);
  }

  function fitAll() {
    document.querySelectorAll('.buy-3-get-1-promo').forEach(fitPromo);
    fitAllCartDrawerTitles();
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  var onResize = debounce(fitAll, 100);

  function bindCartDrawer() {
    var cd = document.getElementById('cart-drawer');
    if (!cd || cd.dataset.buy3PromoFitBound === '1') return;
    cd.dataset.buy3PromoFitBound = '1';
    cd.addEventListener('dialog:after-show', function () {
      requestAnimationFrame(function () {
        fitAll();
      });
    });
  }

  function init() {
    bindCartDrawer();
    fitAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', onResize);
  document.addEventListener('cart-drawer:refreshed', function () {
    bindCartDrawer();
    requestAnimationFrame(fitAll);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitAll);
  }
})();
